import styled from 'styled-components'

export const Card = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  max-width: 501px
  height: 70px;
  background: white;
  padding: 1rem;
  border-radius: 20px;
  box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8);
  margin-bottom:1rem;
`
export const Text = styled.div`
  margin-left: 10px;
  width: 100%;
  display: grid;
  grid-template-columns: 10% 28% 17% 15% 15% 15%;
  @media (max-width: 768px) {
    grid-template-columns: 15% 35% 25% 25%;
  }
`
export const ValueItem = styled.div`
  margin: 10px;
`

export const DetailValue = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 17px;
`
export const DetailLabel = styled.p`
  font-size: 12px;
`
export const NameLabel = styled.div`
  display: flex;
  align-items: center;
  margin: 10px;
`

export const DetailNumber = styled.div`
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: #505887;
`

export const DetailNumberMobileHidden = styled(DetailNumber)`
  margin-top: 10px;
  @media (max-width: 768px) {
    display: none;
  }
`
